import { FC } from 'react';
import { TableTab } from '@models/document/IDocumentScheme';
import AttachGrid from './AttachGrid/AttachGrid';

export interface IDocumentTabAttachTableProps {
    id?: string;
    attachTable: TableTab;
    docId: string;
}

const DocumentTabAttachTable: FC<IDocumentTabAttachTableProps> = ({ id = undefined, attachTable, docId }) => (
    <div className="attach-table" data-testid={id ? `attach-table-${id}` : undefined}>
        <AttachGrid docId={docId} tableTab={attachTable} testId={id} />
    </div>
);

export default DocumentTabAttachTable;
